import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

export default function Listas() {
  const { user } = useAuth();
  const [listas, setListas] = useState({});
  const [nuevo, setNuevo] = useState({});

  const load = () => api.get("/listas").then((r) => setListas(r.data));
  useEffect(() => { load(); }, []);

  if (user && user.role !== "admin") return <Navigate to="/" replace />;

  const guardar = async (tipo, valores) => {
    try {
      await api.put(`/listas/${tipo}`, { valores });
      setListas((prev) => ({ ...prev, [tipo]: { ...prev[tipo], valores } }));
      toast.success("Lista actualizada");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const agregar = (tipo) => {
    const v = (nuevo[tipo] || "").trim();
    if (!v) return;
    const actuales = listas[tipo].valores;
    if (actuales.includes(v)) { toast.error("Ese valor ya existe"); return; }
    guardar(tipo, [...actuales, v]);
    setNuevo({ ...nuevo, [tipo]: "" });
  };

  const quitar = (tipo, val) => guardar(tipo, listas[tipo].valores.filter((x) => x !== val));

  return (
    <div className="p-6 lg:p-8 max-w-5xl">
      <div className="mb-8">
        <h1 className="font-head text-3xl font-extrabold tracking-tight">Listas cerradas</h1>
        <p className="text-slate-500 mt-1">Valores de los dropdowns. Solo el administrador puede editarlos.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {Object.entries(listas).map(([tipo, info]) => (
          <Card key={tipo} className="border-slate-200 shadow-sm p-5" data-testid={`lista-${tipo}`}>
            <h3 className="font-head font-bold tracking-tight">{info.label}</h3>
            <div className="flex flex-wrap gap-2 mt-4">
              {info.valores.map((v) => (
                <span key={v} className="inline-flex items-center gap-1.5 text-sm bg-slate-100 text-slate-700 rounded-full pl-3 pr-1.5 py-1">
                  {v}
                  <button onClick={() => quitar(tipo, v)} className="hover:text-red-600 transition-colors" data-testid={`remove-${tipo}-${v}`}><X size={14} /></button>
                </span>
              ))}
            </div>
            <div className="flex gap-2 mt-4">
              <Input
                value={nuevo[tipo] || ""}
                onChange={(e) => setNuevo({ ...nuevo, [tipo]: e.target.value })}
                onKeyDown={(e) => e.key === "Enter" && agregar(tipo)}
                placeholder="Agregar valor…"
                className="h-9"
                data-testid={`input-${tipo}`}
              />
              <Button size="sm" className="h-9" onClick={() => agregar(tipo)} data-testid={`add-${tipo}`}><Plus size={15} /></Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
